<template>
    <div>
        <div
            v-if="!_.isEmpty(subFields)"
            class="fin-grid fin-grid-cols-1 fin-grid-flow-row fin-gap-x-5"
            :class="`xl:fin-grid-cols-${field.columnCount}`">

            <template v-if="_.isArray(pageColumns)">
                <template v-for="(column, columnKey) in pageColumns">
                    <template v-for="(subField, subFieldKey) in subFields">
                        <field-group :field="subField" :field-key="subFieldKey" :path="`${path}.${columnKey}`">
                            <template v-if="subField.type == 'pageColumns'">
                                <component
                                    :value="fieldValue(subField.type !== 'customField' ? '1' : '5', columnKey, subField)"
                                    :key="`${_uid}`"
                                    :is="subField.component"
                                    :field="subField"
                                    :field-key="subFieldKey"
                                    :path="subField.type !== 'customField' ? `${path}.${columnKey}` : `customFields.${getFieldId(subField)}`"
                                    :disabled="disabled"
                                    :form-store="formStore"
                                >
                                </component>
                            </template>
                            <template v-else>
                                <component
                                    :value="fieldValue(subField.type !== 'customField' ? '2' : '5', columnKey, subField)"
                                    :key="`${_uid}-${getFieldId(subField)}`"
                                    :is="subField.component"
                                    :field="subField"
                                    :field-key="subFieldKey"
                                    :path="subField.type !== 'customField' ? `${path}.${columnKey}.${getFieldId(subField)}` : ''"
                                    :disabled="disabled"
                                    :form-store="formStore">
                                </component>
                            </template>
                        </field-group>
                    </template>
                </template>
            </template>
            <template v-else>
                <template v-for="(subField, subFieldKey) in subFields">
                    <field-group :field="subField" :field-key="subFieldKey" :path="path">
                        <template v-if="subField.type == 'pageColumns'">
                            <component
                                :value="fieldValue(subField.type !== 'customField' ? '3' : '5', subFieldKey, subField)"
                                :key="`${_uid}-${subFieldKey}`"
                                :is="subField.component"
                                :field="subField"
                                :field-key="subFieldKey"
                                :path="subField.type !== 'customField' ? `${path}` : ''"
                                :disabled="disabled"
                                :form-store="formStore">
                            </component>
                        </template>
                        <template v-else>
                            <component
                                :value="fieldValue(subField.type !== 'customField' ? '4' : '5', subFieldKey, subField)"
                                :key="`${_uid}-${subFieldKey}-${getFieldId(subField)}`"
                                :is="subField.component"
                                :field="subField"
                                :field-key="subFieldKey"
                                :path="subField.type !== 'customField' ? `${path}.${getFieldId(subField)}` : `customFields.${getFieldId(subField)}`"
                                :disabled="disabled"
                                :form-store="formStore">
                            </component>
                        </template>
                    </field-group>
                </template>
            </template>

        </div>
    </div>
</template>

<script>
import formMixin from "@tenant/app-form/mixins/formMixin"
import { mapGetters } from "vuex"

import fieldGroup from "@tenant/app-form/components/form/fieldGroup"

export default {
    name: "PageColumns",

    components: {
        fieldGroup,
    },

    mixins: [formMixin],

    props: {
        field: {
            required: true,
            type: [Object, Array],
        },
        fieldKey: {
            required: true,
            type: Number,
        },
        path: {
            required: true,
            type: [String, Number]
        },
        value: {
            required: false,
        },
        disabled: {
            required: false,
            default: false,
        },
        formStore: {
            required: false,
            type: String,
            default: "formStore"
        },
    },

    computed: {
        pageData() {
            if (_.isEmpty(this.formPages)) return []
            return this.formPages.filter((page) => _.isArray(page))
        },
        subFields() {
            if (_.isEmpty(this.field.subFields)) return []
            return this.field.subFields
        },
    },

    data() {
        return {
            pageColumns: {},
        }
    },

    mounted() {},

    methods: {
        fieldValue(section, columnKey, subField) {
            switch(section) {
                case '1':
                    return _.get(this.pageColumns, columnKey)
                    break
                case '2':
                    return _.get(this.pageColumns, `${columnKey}.${this.getFieldId(subField)}`)
                    break
                case '3':
                    return this.pageColumns
                    break
                case '4':

                    let subFieldId = this.getFieldId(subField)

                    // turn a comma seperated sub field mapping into an array
                    let subFieldMapping
                    let subFieldMappingArray = subFieldId ? String(subFieldId).split(",") : []
                    if ([0, 1].includes(_.size(subFieldMappingArray))) {
                        subFieldMapping = subFieldId
                    } else {
                        subFieldMapping = subFieldMappingArray.map(subFieldMapping => subFieldMapping.trim())
                    }

                    if (_.isArray(subFieldMapping)) {
                        let mappingObject = {}
                        subFieldMapping.forEach(mapping => {
                            _.set(mappingObject, mapping, _.get(this.pageColumns, mapping, null))
                        })
                        return mappingObject
                    } else {
                        if (this.isFrontend && _.isEmpty(this.pageColumns)) {
                            return _.get(this.formData, this.getFieldId(subField))
                        } else {
                            return _.get(this.pageColumns, this.getFieldId(subField))
                        }
                    }

                    break
                case '5':
                    return _.get(this.formData.customFields, this.getFieldId(subField))
                    break
            }
        }
    },

    watch: {
        pageColumns: {
            handler(pageColumns) {
                let path = String(this.path).split(".")
                this.setPathData(path, pageColumns)
            },
            deep: true
        },
        value: {
            handler(value) {
                if (!_.isEmpty(value)) {
                    this.pageColumns = value
                }
            },
            deep: true,
            immediate: true,
        },
    },
}
</script>

<style lang="scss" scoped></style>
